const Portfolio = {
  init() {
    Portfolio.events();

  },

  events() {
    $(".portfolio-nav__link").on("click", (e) => {

      // Set active class for item
      $(".portfolio-nav__link").removeClass("active");
      $(e.currentTarget).addClass("active");
    });
  },


};

export default Portfolio;
